export default "__VITE_ASSET__CHWxhLzl__"